import React from "react";
import { connect } from "react-redux";
import BackButton from "./BackButton";
import ToggleButton from "./ToggleButton";
import AddRule from "./AddRule";
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Close from "@material-ui/icons/Close";
import Button from "components/CustomButtons/Button.jsx";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
import Selections from "./Selections";
import pencil from "assets/img/pencil.svg";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import TextField from "@material-ui/core/TextField";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

let globalVar = false;
class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state = {
      tl: false,
      tc: false,
      tr: false,
      bl: false,
      bc: false,
      br: false,
      classicModal: false
    };
    globalVar = false;
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  handleChangeInput = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  componentWillUnmount() {
    var id = window.setTimeout(null, 0);
    while (id--) {
      window.clearTimeout(id);
    }
  }
  handleClickDeleteSegment() {
    this.props.dispatch({ type: "DELETE_SEGMENT", payload: this.props.selectedIndex });
    this.props.dispatch({ type: "Add_SEGMENT" });
  }
  handleClickOpen() {
    var x = [];
    x["classicModal"] = true;
    globalVar = true;
    this.setState(x);
  }
  handleClose() {
    var x = [];
    x["classicModal"] = false;
    globalVar = false;
    this.setState(x);
  }

  render() {
    if (this.props.isModalOpenSegment == "close") {
      this.handleClose();
      var x = [];
      x["classicModal"] = false;
      globalVar = false;
      this.setState(x);
      this.props.dispatch({ type: "CLOSE_MODEL_SEGMENT", payload: "" });
      this.props.dispatch({ type: "Add_SEGMENT" });
    }

    const { classes } = this.props;
    let htmlContent = "";
    if (globalVar) {
      htmlContent = (
        <Selections
          selectedIndex={this.props.selectedIndex}
          selectedRule={this.props.selectedRule}
          mode={this.props.mode}
          type={this.props.type}
        />
      );
    }
    let button;
    if (this.props.buttonType == "button") {
      button = (
        <Button
          color="primary"
          className={classes.marginRight}
          onClick={() => this.handleClickOpen()}
        >
          {this.props.buttonLabel}
        </Button>
      );
    } else if (this.props.buttonType == "add group") {
      button = (
        <Button
          className="btn btncreate"
          color="secondary"
          onClick={() => this.handleClickOpen()}
        >
          ADD SEGMENT
        </Button>
      );
    } else if (this.props.buttonType == "add rule") {
      button = (
        // <a onClick={() => this.handleClickOpen()} className="withoutbgbtn">
        //   {this.props.buttonLabel}
        // </a>
        <div>
          <div
            style={{
              backgroundColor: "#69ff45",
              paddingLeft: "5px",
              marginTop: "2px",
              paddingRight: "5px",
              display: "inline",
              paddingBottom: "3px",
              paddingTop: "1px",
              borderRadius: "2px"
            }}
          >
            <b>
              <a
                style={{
                  marginRight: "0",
                  textDecoration: "none",
                  color: "white"
                }}
                onClick={() => this.handleClickOpen()}
              >
                {/* {this.props.buttonLabel} */}
                ADD RULE
              </a>
            </b>
          </div>
          &nbsp; &nbsp; &nbsp;
          <div
            style={{
              backgroundColor: "#69ff45",
              paddingLeft: "5px",
              marginTop: "2px",
              paddingRight: "5px",
              display: "inline",
              paddingBottom: "3px",
              paddingTop: "1px",
              borderRadius: "2px"
            }}
          >
            <b>
              <a
                style={{
                  marginRight: "0",
                  textDecoration: "none",
                  color: "white"
                }}
                onClick={() => this.handleClickDeleteSegment()}
              >
                DELETE SEGMENT
              </a>
            </b>
          </div>
        </div>
      );
    } else if (this.props.buttonType == "edit button") {
      button = (
        <Button
          style={{ textAlign: "center" }}
          className="btn btncreate editableicon"
          color="success"
          onClick={() => this.handleClickOpen()}
        >
          <i className="fa fa-edit" />
        </Button>
      );
    } else {
      button = (
        <a className={this.props.class} onClick={() => this.handleClickOpen()}>
          <img src={pencil} alt="pencil" />
        </a>
      );
    }
    let content = globalVar === true ? 
        (<Dialog
          disableBackdropClick
          disableEscapeKeyDown
          classes={{
            root: classes.left + " " + classes.modalRoot,
            paper: classes.modal
          }}
          fullWidth={true}
          fullScreen={true}
          maxWidth="md"
          open={this.state.classicModal}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose()}
          aria-labelledby="classic-modal-slide-title"
          aria-describedby="classic-modal-slide-description"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
            style={{
              backgroundColor: "#69ff45",
              borderTopLeftRadius: "6px",
              borderTopRightRadius: "6px"
            }}
          >
            <Button
              style={{ color: "#fff" }}
              justIcon
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              color="transparent"
              onClick={() => this.handleClose()}
            >
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle} style={{ color: "#fff" }}>
              <b>{this.props.titleName ? this.props.titleName : 'Add Segment'}</b>
            </h4>
          </DialogTitle>
          {htmlContent}
        </Dialog>) : ""
    return (
      <React.Fragment>
        {button}
        {content}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  countSegment: state.countSegment,
  tillSqlSelectionArrSegment: state.tillSqlSelectionArrSegment,
  afterSqlSelectionArrSegment: state.afterSqlSelectionArrSegment,
  ruleLeveltoggleSegment: state.ruleLeveltoggleSegment,
  groupLeveltoggleSegment: state.groupLeveltoggleSegment,
  isModalOpenSegment: state.isModalOpenSegment,
  segmentName: state.segmentName
});

export default connect(mapStateToProps)(withStyles(notificationsStyle)(Modal));



// WEBPACK FOOTER //
// ./src/views/Audiences/SegmentQueryBuilder/Modal.jsx